// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3R5PN","label":"Section_label__1AqFg","contentWrap":"Section_contentWrap__TDCvI","footer":"Section_footer__13zt7","footerInner":"Section_footerInner__3EvFH"};